import { SET_APPLICANT_ID } from 'src/store/actions/types';

/**
 * commits the id to the store using the SET_APPLICANT_ID action type
 */
export const setApplicantId = ({ commit }, id) => commit(SET_APPLICANT_ID, id);
